import React, { useState, useEffect } from "react";

function ClientReviewJegadheesanJayavel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = [
    {
      name: "- Kappi V",
      location: "Apex, NC",
      contentHeading:
        "Exceptional Service: Honest, Prompt, and Best Deal Offered! ",
      content:
        "I had the pleasure of working with Jegadheesan during my mortgage process, and I cannot recommend him highly enough. He is honest, prompt, transparent, always demonstrating complete professionalism—even when I was exploring options with others to determine what was best for me. What stood out most was his approach—he didn’t try to time the market or push unnecessary products, but instead focused on understanding my needs and offering the best possible deal. His professionalism and dedication ensured I got a competitive rate, and his communication throughout the process was impeccable. If you’re looking for someone trustworthy and efficient to guide you through the mortgage process, look no further...Jegadheesan is the person to call.",
    },
    {
      name: "- Ashutosh",
      location: "Cary, NC",
      contentHeading: "Very prompt and knowledgable! ",
      content:
        "Thank you, Jegadheesan, for handling my mortgage work very professionally. Your timely followup and assistance made the whole process effortless. You are the best! and I'd definitely recommend my friends and colleagues.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox">
        {reviews.map((review, index) => (
          <div
            className={`OurSatisfiedContentBox ${
              index === currentIndex ? "active" : "inactive"
            }`}
            key={index}
          >
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              <span className="OurSatisfiedName">{review.contentHeading}</span>
              {review.content}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{review.name}</span>
              <span className="OurSatisfiedLocation">{review.location}</span>
            </span>
          </div>
        ))}
      </div>
      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={handlePrev}
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={handleNext}
        ></i>
      </span>
    </div>
  );
}

export default ClientReviewJegadheesanJayavel;
